import * as React from "react";
import { useRef } from "react";
import { motion, sync, useCycle } from "framer-motion";
import { useDimensions } from "./use-deminsions";
import { MenuToggle } from "./MenuToggle";
import { Navigation } from "./Navigation";
import "./style.scss";

const sidebar = {
	open: (height = 1000) => ({
		clipPath: `circle(${height * 2 + 200}px at 40px 40px)`,
		transition: {
			type: "spring",
			stiffness: 20,
			restDelta: 2,
		},
	}),
	closed: {
		clipPath: "circle(30px at 40px 40px)",
		transition: {
			delay: 0.5,
			type: "spring",
			stiffness: 400,
			damping: 40,
		},
	},
};

const sidebar1 = {
	open: (width = 400) => ({
		clipPath: `circle(${width * 2 + 200}px at calc(100% - 40px) 40px)`,
		transition: {
			type: "spring",
			stiffness: 20,
			restDelta: 2,
		},
	}),
	closed: {
		clipPath: "circle(30px at calc(100% - 40px) 40px)",
		transition: {
			delay: 0.5,
			type: "spring",
			stiffness: 400,
			damping: 40,
		},
	},
};

const MobileNav = () => {
	const [isOpen, toggleOpen] = useCycle(false, true);
	const containerRef = useRef(null);
	const { height } = useDimensions(containerRef);
	const func = () => {
        console.log("clicked");
	};

	return (
		<div className={`mobileNavWrap ${isOpen && "active"}`}>
			<motion.nav
				style={{
					width: isOpen ? "300px" : "50px",
					height: isOpen ? "unset" : "50px",
				}}
				initial={false}
				animate={isOpen ? "open" : "closed"}
				custom={height}
				ref={containerRef}
			>
				<div
					className="menuMain"
					style={{ display: isOpen ? "block" : "none" }}
				>
					<motion.div className="background" variants={sidebar1} />
					<Navigation toggleOpen={toggleOpen} />
					<div
						className="toggleBG"
						toggleOpen={toggleOpen}
						onClick={func}
					></div>
				</div>
				<MenuToggle toggle={() => toggleOpen()} />
			</motion.nav>
		</div>
	);
};

export default MobileNav;
